<template>
  <div class="monitor">
    <div :id="`${modelactiveCount === 1 ? 'left2' : 'left'}`">
      <!-- 安全运行天数 -->
      <div class="run-time">
        <Title :text="basicData.SafeOperationDays.Title[0]" :engText="basicData.SafeOperationDays.Title[1]"></Title>
        <div class="left-content">
          <div class="run">
            <div class="icon"></div>
            <div class="content">
              <div>运行开始时间</div>
              <div>{{basicData.SafeOperationDays.StartTime}}</div>
            </div>
          </div>
          <div class="time">
            <div class="icon"></div>
            <div class="content">
              <div>已运行时间</div>
              <div>{{basicData.SafeOperationDays.ElapsedTime}}天</div>
            </div>
          </div>
        </div>
      </div>
      <div class="border-Row"></div>
      <!--报警事件  -->
      <div class="warning-event">
        <Title :text="basicData.AlarmEvent.Title[0]" :engText="basicData.AlarmEvent.Title[1]"></Title>
        <div class="tab-content">
          <div class="thead">
            <div class="tr">
              <div class="th" v-for="(item,i) in basicData.AlarmEvent.table.thead" :key="i">{{item}}</div>
            </div>
          </div>
          <div class="tbody">
            <div class="tr" v-for="item in basicData.AlarmEvent.table.tbody" :key="item.i">
              <div class="td">{{item.i}}</div>
              <div class="td">{{item.CheckPoint}}</div>
              <div class="td">{{item.Type}}</div>
              <div class="td">{{item.Time}}</div>
              <div class="td">
                <div class="icon"></div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
      <div class="border-Row" v-if="basicData.option.monitor[0].active"></div>
      <!--设备状态统计  -->
      <div class="placeholder-border" v-if="basicData.option.monitor[0].active">
        <DeviceStatus></DeviceStatus>
      </div>
    </div>
    <div id="bottom"></div>
  </div>
</template>

<script>
import Title from '../components/title/index.vue';
import { mapState,mapActions } from 'pinia' //引入映射函数
import useStore from '@/store/index' //引入store
import DeviceStatus from '@/moduleComponents/monitor/DeviceStatus.vue'
export default {
  components: {
    Title,
    DeviceStatus
  },
  data () {
    return {
      modelState:[]
    }
  },
  computed:{
    ...mapState(useStore,['home','basicData']),
    modelactiveCount(){
      this.modelState = JSON.parse(JSON.stringify(this.basicData.option['monitor']))
        let count = 0
        this.modelState.forEach(item =>{
          if(item.active){
            count++;
          }
        })
        return  count
    }
    
  },
  mounted () {
  }
}
</script>

<style scoped>
.monitor{
  width: 100%;
  height: 100%;
}
#left{
  width: 338px;
  /* background: red; */
  position: absolute;
  top: 82px;
  left: 18px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  
}
 .run-time{
  height: 110px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* background-color: #3d91ff; */
}
 .run-time .left-content{
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
 .run-time .left-content >div{
  width: 155px;
  height: 65px;
  background: url('@/assets/img/bgd3.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
 .run-time .left-content .run .icon{
  width: 27px;
  height: 27px;
  background: url('@/assets/img/video-icon.png') no-repeat;
  background-size: 100% 100%;
}
 .run-time .left-content .time .icon{
  width: 27px;
  height: 27px;
  background: url('@/assets/img/time.png') no-repeat;
  background-size: 100% 100%;
}
 .run-time .left-content .run .content,
 .run-time .left-content .time .content{
  width: 109px;
  height: 49px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
 .run-time .left-content .run .content >div:nth-child(1),
 .run-time .left-content .time .content >div:nth-child(1){
  font-size: 13px;
  color: #7b8fbb;
}
 .run-time .left-content .run .content >div:nth-child(2),
 .run-time .left-content .time .content >div:nth-child(2){
  font-size: 17px;
  margin-top: 5px;
}
 .warning-event{
  height: 216px;
  /* flex: .8; */
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
 .warning-event .tab-content{
  flex: 1;
  width: 100%;
  margin-top: 7px;
  display: flex;
  flex-direction: column;
  overflow:hidden;
}
 .warning-event .tab-content .thead{
  border-bottom: 1.5px solid #bdd3ff24;
  box-sizing: border-box;
  margin-bottom: 2px;
}
 .warning-event .tab-content .thead .tr{
  background-color: #093aa35c;
}
 .warning-event .tab-content .tbody .tr .td:nth-child(5) .icon{
  width: 21px;
	height: 13px;
  background:url('@/assets/img/查看.png') no-repeat;
  background-size: 100% 100%;
}
#bottom{
  /* width: calc(100vw - 328px - 40px); */
  height: 276px;
  /* background: darkcyan; */
  position: absolute;
  bottom: 20px;
  left: 350px;
  overflow: hidden;
  display: flex;
}
</style>